export default {
  lookupUser: '/mrx-gateway/mrxassistmemberservice/admin/api/user/lookup',
  lookupUserHistory: userId => `/mrx-gateway/mrxassistmemberservice/admin/api/user/${userId}/groupHistory`,
  userToGroup: (userId, groupId) => `/mrx-gateway/mrxassistmemberservice/admin/api/user/${userId}/group/${groupId}`,
  createUser: '/mrx-gateway/mrxassistmemberservice/admin/api/user/create'
}
